export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-blue-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/060e1c25caffef29cb7917b5a22faf7c/16acb801c9742b924ec5abef0621b19e.png"
                alt="Nova Imagem - Diagnóstico por Imagem"
                className="h-16 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-white/80 leading-relaxed mb-6">
              Tecnologia de ponta e atendimento humanizado para cuidar da sua saúde com precisão e confiança.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('inicio')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Início
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('sobre')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Sobre a Clínica
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('exames')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Exames
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('convenios')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Convênios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('agendamento')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Agendamentos e Contato
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Exames</h4>
            <ul className="space-y-3">
              <li className="text-white/80">Ressonância Magnética</li>
              <li className="text-white/80">Tomografia</li>
              <li className="text-white/80">Raio-X Digital</li>
              <li className="text-white/80">Ultrassom</li>
              <li className="text-white/80">Mamografia</li>
              <li className="text-white/80">Densitometria Óssea</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-xl mt-1"></i>
                <div>
                  <a href="tel:+553534311899" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                    (35) 3431-1899
                  </a>
                  <br />
                  <a href="tel:+553534314558" className="text-white/80 hover:text-white transition-colors cursor-pointer text-sm">
                    (35) 3431-4558
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-whatsapp-line text-xl mt-1"></i>
                <div>
                  <a href="https://wa.me/5535988228452" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                    (35) 98822-8452
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-xl mt-1"></i>
                <div>
                  <a href="mailto:novaimagemcambui@hotmail.com" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                    novaimagemcambui@hotmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-xl mt-1"></i>
                <div className="text-white/80 text-sm">
                  Rua Vereador Waldomiro Bueno, 130<br />
                  Cambuí - MG
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              © 2025 Nova Imagem Diagnóstico por Imagem. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <a href="#" className="text-white/60 hover:text-white transition-colors cursor-pointer">
                Política de Privacidade
              </a>
              <a href="#" className="text-white/60 hover:text-white transition-colors cursor-pointer">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
